import PersonIcon from "@mui/icons-material/Person";
import Chip from "@mui/material/Chip";
import Link from "next/link";

export default function DebtorChip({ debtor_code, debtor_id, is_back_office = false }) {
	return (
		<LinkWrapper is_back_office={is_back_office} debtor_id={debtor_id}>
			<Chip label={debtor_code} size="medium" icon={<PersonIcon fontSize="small" />} />
		</LinkWrapper>
	);
}

function LinkWrapper({ children, is_back_office = false, debtor_id = null }) {
	if (!is_back_office) {
		return children;
	}

	return (
		<Link href={`/back-office/customers/debtor/${debtor_id}`} passHref>
			{children}
		</Link>
	);
}
